import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TicketListView } from "@royalty/model";
import { OAuthService } from "@royalty/oauth2";
import { BehaviorSubject } from "rxjs";
import { AppUtils } from "src/app/core/utils/app-utils";
import { SignalRService } from "src/app/core/websocket/signalr.service";

const URL_HUB = "/posadhub";

@Injectable()
export class PosAdHubSignalRService extends SignalRService {
	syncTicketsChanged$ = new BehaviorSubject<TicketListView[]>(null);
	noticeTicketIsUpdatedChanged$ = new BehaviorSubject<TicketListView>(null);

	constructor(private oAuthService: OAuthService, protected http: HttpClient) {
		super(http);
		this.createConnection(URL_HUB,
			{
				withAuthenticate: true,
				withAutomaticReconnect: AppUtils.isMobileApp,
				accessToken: () => this.oAuthService.getAccessToken()
			});
		this.registerOnServerEvents();
		this.startConnection();
	}

	registerOnServerEvents(): void {
		this.hubConnection.on("SyncTickets", (data: TicketListView[]) => {
			this.syncTicketsChanged$.next(data);
		});
		this.hubConnection.on(
			"NoticeTicketIsUpdated",
			(data: TicketListView) => {
				this.noticeTicketIsUpdatedChanged$.next(data);
			}
		);
	}

	syncTickets() {
		if (this.isConnected()) {
			this.hubConnection.invoke("SyncTickets");
		}
	}
}
